<app-header></app-header>
<div class="container">
  <div class="row">
    <div class="col-10">
      <h2>Alumnos</h2>
    </div>
    <div
      *ngIf="admin"
      class="col-2 d-flex"
      style="align-items: center; justify-content: end"
    >
      <label for="periodo" class="mx-2">Periodo:</label>
      <select
        [(ngModel)]="periodo"
        class="form-control"
        name="periodo"
        id="periodo"
        style="width: 3.5rem"
        (change)="cambioPeriodo()"
      >
        <option value="252" selected>252</option>
        <option value="251">251</option>
        <option value="242">242</option>
        <option value="241">241</option>
        <option value="232">232</option>
        <option value="231">231</option>
        <option value="222">222</option>
      </select>
    </div>
  </div>
  <div>
    <table
      *ngIf="alumnos.length"
      class="table table-bordered table-striped table-hover"
      datatable
      [dtOptions]="dtOptions"
    >
      <thead>
        <tr style="background-color: #002061; color: #eee">
          <th>NIVEL</th>
          <th>CARRERA</th>
          <th>GRUPO</th>
          <th>MATRÍCULA</th>
          <th>NOMBRE</th>
          <!-- <th>CLAVE DOCENTE</th> -->
          <th>TUTOR</th>
          <th style="width: 15%">VER SESIONES</th>
          <th *ngIf="admin">SESIÓN INDIVIDUAL</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let alumno of alumnos">
          <td>{{ alumno.nivel }}</td>
          <td>{{ alumno.carrera }}</td>
          <td>{{ alumno.grupo }}</td>
          <td>{{ alumno.matricula }}</td>
          <td>{{ alumno.alumno_nombre }}</td>
          <!-- <td>{{ alumno.cve_docente }}</td> -->
          <td>{{ alumno.tutor }}</td>
          <td>
            <button
              class="btn btn-color2"
              (click)="
                verSesion(
                  alumno.matricula,
                  alumno.alumno_nombre,
                  alumno.sub_cve_subgrupo,
                  alumno.tutor
                )
              "
            >
              Ver sesiones <fa-icon [icon]="icon1"></fa-icon>
            </button>
          </td>
          <td *ngIf="admin">
            <button
              class="btn btn-color3"
              (click)="
                registrar(
                  alumno.matricula,
                  alumno.alumno_nombre,
                  alumno.sub_cve_subgrupo,
                  alumno.tutor
                )
              "
            >
              Registrar <fa-icon [icon]="icon2"></fa-icon>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
    <h5 *ngIf="!alumnos.length && !loading" style="color: rgb(102, 4, 4)">
      *No hay alumnos
    </h5>
    <section class="dots-container" *ngIf="loading">
      <div class="dot"></div>
      <div class="dot"></div>
      <div class="dot"></div>
      <div class="dot"></div>
      <div class="dot"></div>
    </section>
  </div>
</div>

<!-- <div id="comp-render" *ngIf="displayRegistroIndividual && !displayGrupo">
    <button class="btn btn-color2" (click)="volverAAlumnos()">Volver</button>
    
</div>

<div id="comp-render" *ngIf="displayGrupo && !displayRegistroIndividual">
    <app-grupos></app-grupos>
</div> -->
